import(/* webpackMode: "eager", webpackExports: ["TermsContent"] */ "/app/apps/platform-web/app/legal/terms/TermsContent.tsx");
